var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E3627D87-20E4-4F01-A1BE-AADB1662A9B1-403-00002DD839C893A7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    color: "initial",
    d: "M3.9593605,8 L9.85631767,13.8084377 C10.0478941,13.9971383 10.0478941,14.3030826 9.85631767,14.4917833 L8.46879833,15.8584745 C8.27722189,16.0471752 7.96661511,16.0471752 7.77503867,15.8584745 L0.143682332,8.3416728 C-0.0478941105,8.15297212 -0.0478941105,7.84702788 0.143682332,7.6583272 L7.77503867,0.141525509 C7.96661511,-0.0471751698 8.27722189,-0.0471751698 8.46879833,0.141525509 L9.85631767,1.50821673 C10.0478941,1.6969174 10.0478941,2.00286165 9.85631767,2.19156233 L3.9593605,8 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investment-viewfinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.4a-geographic-priorities---domestic",
    transform: "translate(-147.000000, -166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "questionnaire",
    transform: "translate(135.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/left",
    transform: "translate(12.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(6.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_left",
    fill: "#8A8888",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeft);
export default __webpack_public_path__ + "static/media/ic_left.37760c68a00810b5b365a753deee127d.svg";
export { ForwardRef as ReactComponent };